import { Enums } from "../../../models/common"
import { OpDevice, OpLocation, OpMeter } from "../../../models/core"

export type RowData = {
    id: number,
    name: string,
    [key: string]: any
}

export type Tooltip = {
    id: number[],
    name: string
}

export type DetailsReferenceType = OpLocation | OpDevice | OpMeter

export interface GridDetailsSettings {
    objects: any[]

    eventNameForSchemaChanged?: string

    measurmentIdsField: string
    measurmentIdField: string
    // for multiselect
    measurmentIdFields?: string[]
    measurmentIdSaveTo?: string
    measurmentIdsFields?: any | {
        fieldIdName: string,
        objectName: string
    }[]
    // ---    

    filterId: DetailsCorrelationFilterType

    referenceType: Enums.ReferenceType
    noDataText?: string

    moduleName: Enums.SimaxModuleName

    refreshDelegate: () => void
}

export enum DetailsCorrelationFilterType {
    Location = 1,
    Device = 2,
    Meter = 3
}